import { useEffect, useState } from 'react';
export var useClientListFilterState = function (_a) {
    var activeView = _a.activeView;
    var _b = useState(''), clientFilter = _b[0], setClientFilter = _b[1];
    useEffect(function () {
        setClientFilter('');
    }, [activeView]);
    var filterClientsFn = function (row) {
        var user = row.getValue('clients');
        var userInfo = "".concat(user.firstName, " ").concat(user.lastName, " ").concat(user.phone).toLowerCase();
        return userInfo.includes(clientFilter.toLowerCase());
    };
    return {
        clientFilter: clientFilter,
        setClientFilter: setClientFilter,
        filterClientsFn: filterClientsFn,
    };
};
